"use strict";
exports.__esModule = true;
var constants = {
    BORDER_COLOR: '#DDDDDD',
    TITLE_MAX_LENGTH: 50,
    Z_INDEX: 101,
    TREE_INITIALLY_EXPANDED: true
};
exports["default"] = constants;
